import { resetCompetition } from "./actions";
import {
  CLASS_SUBTOPIC_OVERALL_REPORT_REQUESTED,
  CLASS_SUBTOPIC_OVERALL_REPORT_SUCCESS,
  CLASS_SUBTOPIC_SKILL_REPORT_REQUESTED,
  CLASS_SUBTOPIC_SKILL_REPORT_SUCCESS,
  FETCH_CT_QUESTION_RESET,
  FETCH_CT_QUESTION_SUCCESS,
  LOGOUT_USER_SUCCESS,
  SCHOOL_SUBTOPIC_OVERALL_REPORT_REQUESTED,
  SCHOOL_SUBTOPIC_OVERALL_REPORT_SUCCESS,
  SCHOOL_SUBTOPIC_SKILL_REPORT_REQUESTED,
  SCHOOL_SUBTOPIC_SKILL_REPORT_SUCCESS,
  SELECT_CLASS,
  SELECT_COMPETITION,
  SELECT_SCHOOL,
  SELECT_STUDENT,
  SET_IS_VIEWING_STATUS,
  SUBTOPIC_REPORT_RESET,
  CHANGE_LANGUAGE,
  COMPETITION_RESET_REQUESTED,
  COMPETITION_RESET_FAILURE,
  COMPETITION_RESET_SUCCESS,
  RESET_COMPETITION_RESCHEDULE,
  DOWNLOAD_REPORT_REQUESTED,
  DOWNLOAD_REPORT_SUCCESS,
  DOWNLOAD_REPORT_FAILURE,
} from "./actionTypes";

const initialState = {
  selectedCompetition: null,
  selectedSchool: null,
  selectedClass: null,
  selectedStudent: null,
  isViewingStatus: false,
  resetCompetitionInfo:undefined,
  resetCompetitionLoader: false,
  resetCompetitionSuccess: false,
  resetCompetitionError: false,
  downloadReportLoading:false,
  downloadReportSuccess: false,
  downloadReportError: false,
};

const main = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_LANGUAGE:
			return{
        ...state,
        lang: action.lang,
      } 
    case SELECT_COMPETITION:
      return {
        ...state,
        selectedCompetition: action.competition,
      };
    case SELECT_SCHOOL:
      return {
        ...state,
        selectedSchool: action.school,
      };
    case SELECT_CLASS:
      return {
        ...state,
        selectedClass: action.schoolClass,
      };
    case SELECT_STUDENT:
      return {
        ...state,
        selectedStudent: action.selectStudent,
      };
    case SET_IS_VIEWING_STATUS:
      return {
        ...state,
        isViewingStatus: action.isViewingStatus,
      };
    case SCHOOL_SUBTOPIC_OVERALL_REPORT_REQUESTED:
      return {
        ...state,
        activeTopic: action.payload.activeTopicData
      }
    case SCHOOL_SUBTOPIC_SKILL_REPORT_REQUESTED:
      return {
        ...state,
        activeTopic: action.payload.activeTopicData
      }
    case SCHOOL_SUBTOPIC_OVERALL_REPORT_SUCCESS:
      return {
        ...state,
        schoolSubtopicOverallReportdata: action.resp.data,
      };
    case CLASS_SUBTOPIC_OVERALL_REPORT_REQUESTED:
      return {
        ...state,
        activeTopic: action.payload.activeTopicData
      }
    case CLASS_SUBTOPIC_SKILL_REPORT_REQUESTED:
      return {
        ...state,
        activeTopic: action.payload.activeTopicData
      }
    case CLASS_SUBTOPIC_OVERALL_REPORT_SUCCESS:
      return {
        ...state,
        classSubtopicOverallReportdata: action.resp.data,
      };
    case SCHOOL_SUBTOPIC_SKILL_REPORT_SUCCESS:
      return {
        ...state,
        schoolSubtopicSkillReportdata: action.resp.data,
      };
    case CLASS_SUBTOPIC_SKILL_REPORT_SUCCESS:
      return {
        ...state,
        classSubtopicSkillReportdata: action.resp.data,
      };
    case SUBTOPIC_REPORT_RESET:
      return {
        ...state,
        schoolSubtopicOverallReportdata: undefined,
        classSubtopicOverallReportdata: undefined,
        schoolSubtopicSkillReportdata: undefined,
        classSubtopicSkillReportdata: undefined,
        activeTopic: undefined
      };
    case FETCH_CT_QUESTION_SUCCESS:
      return {
        ...state,
        activeQuestion: action.resp.data
      };
    case FETCH_CT_QUESTION_RESET:
      return {
        ...state,
        activeQuestion: undefined
      };

    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        selectedCompetition: null,
        selectedSchool: null,
        selectedClass: null,
        selectedStudent: null,
        isViewingStatus: false,
      };
    case COMPETITION_RESET_REQUESTED:
      return {
        ...state,
        resetCompetitionLoader: true,
        resetCompetitionError: false,
        resetCompetitionSuccess: false,
      }
    case COMPETITION_RESET_SUCCESS:
      return {
        ...state,
        resetCompetitionLoader: false,
        resetCompetitionError: false,
        resetCompetitionSuccess: true,
        resetCompetitionInfo: action.resp.data
      }
    case COMPETITION_RESET_FAILURE:
      return {
        ...state,
        resetCompetitionLoader: false,
        resetCompetitionError: true,
        resetCompetitionSuccess: false,
        resetCompetitionInfo: undefined
      }
    case RESET_COMPETITION_RESCHEDULE:
      return {
        ...state,
        resetCompetitionLoader: false,
        resetCompetitionError: false,
        resetCompetitionSuccess: false,
        resetCompetitionInfo: undefined
      }
    case DOWNLOAD_REPORT_REQUESTED:
      return {
        ...state,
        downloadReportLoading: true,
        downloadReportError: false,
        downloadReportSuccess: false,
      }
    case DOWNLOAD_REPORT_SUCCESS:
      return {
        ...state,
        downloadReportLoading: false,
        downloadReportError: false,
        downloadReportSuccess: true,
      }
    case DOWNLOAD_REPORT_FAILURE:
      return {
        ...state,
        downloadReportLoading: false,
        downloadReportError: true,
        downloadReportSuccess: false,
      }
    default:
      return state;
  }
};

export default main;
